import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@web/walter-lib/auth'
import { Routes } from '~constants/routes'
import { useIsAuth } from '~hooks/useIsAuth'
import { setRedirectPathname } from '~utils/redirectPathname'

function Guard() {
    const { pathname } = useLocation()

    useEffect(() => {
        setRedirectPathname(pathname)
    }, [pathname])

    return <Navigate to={Routes.signIn} replace />
}

export function RequireAuth() {
    const { isAuth } = useAuth()
    // Check for auth (401 and 403 errors means session is invalid)
    useIsAuth()

    return isAuth ? <Outlet /> : <Guard />
}
